module.exports = __webpack_public_path__ + "static/media/base.88cac58d.png";